"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importStar(require("react"));
var slate_1 = require("slate");
var slate_react_1 = require("slate-react");
var slate_history_1 = require("slate-history");
var PasteUtilities_1 = require("./PasteUtilities");
var Leaf_1 = __importDefault(require("./Leaf"));
var RenderElement_1 = __importDefault(require("./RenderElement"));
var SelectionChangeEvent_1 = require("./SelectionChangeEvent");
var Toolbar_1 = __importDefault(require("./Widgets/TextToolbar/LegacyToolbar/Toolbar"));
var TextToolbar_1 = require("./Widgets/TextToolbar/TextToolbar");
var WidgetAdder_1 = __importDefault(require("./Widgets/WidgetAdder/WidgetAdder"));
var WidgetManager_1 = require("./WidgetManager");
var Router_1 = __importDefault(require("./Router"));
var EditorTypes_1 = require("./EditorTypes");
var InviteNewUser_1 = require("Common/InviteNewUserModal/InviteNewUser");
var Types_1 = require("DataStores/Account/Types");
var Utils_1 = require("./Utils");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var DropUtilities_1 = require("./DropUtilities");
var BlockCrash_1 = require("./BlockCrash");
var SlateUniqueId_1 = require("./SlateUniqueId");
var DropIndicatorLine_1 = __importDefault(require("./DropIndicatorLine/DropIndicatorLine"));
var classnames_1 = __importDefault(require("classnames"));
var TokenSearchServiceContext_1 = __importDefault(require("Project/QwilrEditor/Providers/TokenScope/TokenSearchServiceContext"));
var SlateSelectionStore_1 = require("./SlateSelectionStore");
var DIProvider_1 = __importDefault(require("DIProvider/DIProvider"));
var inversify_1 = require("inversify");
var PlaceholderContext_1 = require("./Placeholder/PlaceholderContext");
var EditorDebugOverlay_1 = require("./EditorDebugStore/EditorDebugOverlay");
var scroll_into_view_if_needed_1 = __importDefault(require("scroll-into-view-if-needed"));
var StylesContext_1 = require("./StylesContext");
var DragContext_1 = require("./RegistryElement/DragContext");
var EditorConfigurationContext_1 = require("./RegistryElement/EditorConfigurationContext");
var DragPreviewImageHost_1 = __importStar(require("./DragPreviewImageHost"));
var ClientColorProvider_1 = require("DreamCoat/ClientColorProvider");
var SlateEditorComponent = (function (_super) {
    __extends(SlateEditorComponent, _super);
    function SlateEditorComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.widgetToolbarHost = (0, react_1.createRef)();
        _this.dragPreviewImageHost = (0, react_1.createRef)();
        _this.waitingForInitialNormalizationToFlush = false;
        _this.dragOutOfEditorListener = function () {
            var _a;
            if (((_a = _this.dropLocationStore.dropLocation) === null || _a === void 0 ? void 0 : _a.editorId) === _this.editor.uniqueId) {
                _this.dropLocationStore.clearDropLocation();
            }
        };
        _this.maybeUpdateClickToAddStore = function () {
            var editor = _this.editor;
            if (editor.selection) {
                var isSavedBlock = _this.props.blockStore.isSavedBlock;
                if (isSavedBlock) {
                    return;
                }
                var widgetManager = _this.widgetManager;
                _this.clickToAddStore.updateLastKnownSelection(widgetManager);
            }
        };
        _this.runRenderElement = function (properties) {
            var _a = _this.props, blockStore = _a.blockStore, brandStore = _a.brandStore, stylePermissionStore = _a.stylePermissionStore, uploadStore = _a.uploadStore, videoEmbedUrlGenerator = _a.videoEmbedUrlGenerator, di = _a.di, blockList = _a.blockList;
            var activeTokenToolbarStore = di.get("activeTokenToolbarStore");
            var widgetAdderStore = di.get("widgetAdderStore");
            var roiStepsOrchestrator = di.get("roiStepsOrchestrator");
            var notifyUser = di.get("notifyUser");
            var blockIndex = blockList.getIndex(blockStore);
            return _this.renderElement(properties, _this.value, _this.editor, _this.widgetManager, _this.onChange, _this.usingFeature, blockStore, brandStore, stylePermissionStore, _this.telemetry, uploadStore, videoEmbedUrlGenerator, activeTokenToolbarStore, blockIndex, _this.getToolBarConfig(), _this.props.configuration.disableWidgetAdder, _this.widgetToolbarHost, _this.dropLocationStore, _this.dragStore, widgetAdderStore, roiStepsOrchestrator, _this.selectionStore, notifyUser);
        };
        _this.runRenderLeaf = function (props) {
            var _a = _this.props, editorElem = _a.editorElem, commentThreadStore = _a.commentThreadStore, di = _a.di;
            var user = di.get("user");
            var usersInAccount = di.get("userList");
            var pendingUsersDataStore = getPendingUsersDataStore(di);
            return (react_1.default.createElement(Leaf_1.default, { widgetManager: _this.widgetManager, properties: props, commentThreadStore: commentThreadStore, user: user, usersInAccount: usersInAccount, editorElem: editorElem, permissionsStore: _this.permissionsStore, projectId: _this.props.projectStore._id, pendingUsersDataStore: pendingUsersDataStore, inviteNewUser: _this.inviteNewUser }));
        };
        _this.getToolBarConfig = function () {
            var _a = _this.props, toolbarConfiguration = _a.configuration.toolbarConfiguration, stylePermissionStore = _a.stylePermissionStore;
            var shouldRemoveStyleToolBar = stylePermissionStore.isStylePermissionEnabled && !stylePermissionStore.allowStyle(Types_1.StyleAccessType.Toolbar);
            return shouldRemoveStyleToolBar
                ?
                    toolbarConfiguration.filter(function (button) {
                        return button.type !== EditorTypes_1.MarkType.Style;
                    })
                : toolbarConfiguration;
        };
        _this.buildInviteUserFunction = function () {
            var rootDataStore = _this.props.di.get("rootDataStore");
            return (0, InviteNewUser_1.createInviteNewUser)(_this.props.di.get("inviteNewUserModal"), _this.props.projectStore._id, _this.props.di.get("modal"), rootDataStore.getAccountDataStore().getUserInvitePermission(), rootDataStore.userDataStore);
        };
        _this.router = props.router;
        _this.saver = props.saver;
        _this.loader = props.loader;
        _this.schema = props.configuration.schema;
        _this.cursorValidator = props.cursorValidator;
        _this.usingFeature = props.usingFeature;
        _this.telemetry = props.di.get("editorTelemetry");
        _this.widgetAdderStore = props.di.get("widgetAdderStore");
        var rootDataStore = props.di.get("rootDataStore");
        _this.permissionsStore = rootDataStore.getPermissionsDataStore();
        _this.projectStore = props.projectStore;
        _this.clickToAddStore = props.di.get("clickToAddStore");
        _this.dropLocationStore = props.di.get("dropLocationStore");
        _this.dragStore = props.di.get("dragStore");
        _this.onChange = _this.onChange.bind(_this);
        _this.loadState = _this.loadState.bind(_this);
        _this.saveFullState = _this.saveFullState.bind(_this);
        _this.router.onEvent = _this.router.onEvent.bind(_this.router);
        _this.loader.loadSlate = _this.loadState;
        _this.saver.saveSlate = _this.saveFullState;
        _this.router.onChange = _this.onChange;
        _this.renderElement = RenderElement_1.default;
        _this.inviteNewUser = _this.buildInviteUserFunction();
        var configuredEditor = (0, Utils_1.createConfiguredEditor)(props.initialState.children, props.initialState.selection, props.configuration.schema);
        var editor = (0, SlateUniqueId_1.withUniqueId)((0, slate_history_1.withHistory)((0, slate_react_1.withReact)(configuredEditor)));
        slate_1.Editor.normalize(editor, { force: true });
        var normalizeProducedOperationsToApply = editor.operations.length > 0;
        _this.waitingForInitialNormalizationToFlush = normalizeProducedOperationsToApply;
        _this.editor = editor;
        _this.value = editor.children;
        _this.selectionStore = new SlateSelectionStore_1.SlateSelectionStore(lodash_1.default.cloneDeep(_this.editor.selection));
        var di = props.di, projectStore = props.projectStore;
        _this.widgetManager = new WidgetManager_1.WidgetManager(_this.router.onEvent, _this.editor, di, projectStore.isEditable, projectStore);
        _this.modal = di.get("modal");
        _this.editorDebugStore = di.get("editorDebugStore");
        return _this;
    }
    SlateEditorComponent.prototype.saveFullState = function () {
        return this.saver.tokeniseWithSelection(this.value, this.selectionStore.currentSelection || undefined);
    };
    SlateEditorComponent.prototype.loadState = function (slateContext) {
        var _a;
        try {
            this.editor.children = slateContext.children;
            this.editor.selection = (_a = slateContext.selection) !== null && _a !== void 0 ? _a : null;
            this.widgetManager.updateEditor(this.editor);
            slate_1.Editor.normalize(this.editor, { force: true });
            this.value = this.editor.children;
        }
        catch (e) {
            console.error(e);
        }
        this.onChange(this.value, true);
    };
    SlateEditorComponent.prototype.componentDidMount = function () {
        window.addEventListener("dragover", this.dragOutOfEditorListener);
        this.editorDebugStore.registerEditor(this.editor);
    };
    SlateEditorComponent.prototype.componentWillUnmount = function () {
        this.clickToAddStore.deregisterEditor(this.editor);
        window.removeEventListener("dragover", this.dragOutOfEditorListener);
        this.editorDebugStore.unregisterEditor(this.editor);
    };
    SlateEditorComponent.prototype.onChange = function (value, blockSave) {
        if (blockSave === void 0) { blockSave = false; }
        this.waitingForInitialNormalizationToFlush = false;
        this.cursorValidator.validateCursor(this.editor);
        this.widgetManager.updateEditor(this.editor);
        this.value = value;
        this.selectionStore.setSelection(lodash_1.default.cloneDeep(this.editor.selection));
        if (this.isSavingOperation(blockSave, this.editor.operations)) {
            try {
                this.saver.save(value);
            }
            catch (e) {
                this.modal.showSimpleModal({
                    isEscapable: false,
                    containerClassName: "block-crashed-modal",
                    body: react_1.default.createElement(BlockCrash_1.BlockCrash, { explanationText: "An error occurred in one of the blocks on this page" }),
                });
                throw e;
            }
        }
        this.maybeTriggerSelectionChangeEvent();
        this.maybeUpdateClickToAddStore();
        this.editorDebugStore.onEditorChange();
    };
    SlateEditorComponent.prototype.maybeTriggerSelectionChangeEvent = function () {
        var e_1, _a;
        var operations = this.editor.operations;
        var shouldTrigger = false;
        try {
            for (var operations_1 = __values(operations), operations_1_1 = operations_1.next(); !operations_1_1.done; operations_1_1 = operations_1.next()) {
                var operation = operations_1_1.value;
                if (operation.type === "set_selection") {
                    shouldTrigger = true;
                    break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (operations_1_1 && !operations_1_1.done && (_a = operations_1.return)) _a.call(operations_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (shouldTrigger) {
            this.editor.operations = [];
            this.router.onEvent(new SelectionChangeEvent_1.SelectionChangeEvent(this.editor), this.editor);
        }
    };
    SlateEditorComponent.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this, telemetry = _b.telemetry, _c = _b.props, brandStore = _c.brandStore, blockStore = _c.blockStore, showImagePicker = _c.showImagePicker, editorElem = _c.editorElem, _d = _c.configuration, disableWidgetAdder = _d.disableWidgetAdder, disableWidgetDragAndDrop = _d.disableWidgetDragAndDrop, placeholderOverrides = _d.placeholderOverrides, conversionElem = _c.conversionElem, uploadStore = _c.uploadStore, projectStore = _c.projectStore, di = _c.di;
        var blockEditorClass = "new-editor--".concat(blockStore.$id);
        var tokenSearchService = di.get("tokenSearchService");
        var isReadOnlyMode = !projectStore.isEditable || projectStore.isBlockLocked(blockStore.blockId);
        var usingNewTextToolbar = this.usingFeature(FeatureFlag_1.default.NewTextToolbar);
        return (react_1.default.createElement(DIProvider_1.default, { container: function () {
                var container = new inversify_1.Container();
                container.bind(EditorTypes_1.SlateEditor.$).toConstantValue(_this.editor);
                container.bind(Router_1.default).toConstantValue(_this.router);
                container.bind("conversionElem").toConstantValue(_this.props.conversionElem);
                container.bind(PlaceholderContext_1.PlaceholderConfig.$).toConstantValue(__assign({ heading1: "Go ahead and start typing", heading2: "Go ahead and start typing", paragraph: function (element) {
                        var pathOfElement = slate_react_1.ReactEditor.findPath(_this.editor, element);
                        var parentNode = slate_1.Node.parent(_this.editor, pathOfElement);
                        var isOnlyChild = parentNode.children.length === 1;
                        if (isOnlyChild && disableWidgetAdder) {
                            return "Add some text";
                        }
                        else {
                            return;
                        }
                    } }, placeholderOverrides));
                container.bind(DragPreviewImageHost_1.DragImagePreviewHostElement.$).toConstantValue(_this.dragPreviewImageHost);
                container.bind(WidgetManager_1.WidgetManager).toConstantValue(_this.widgetManager);
                container.bind(SlateSelectionStore_1.SlateSelectionStore).toConstantValue(_this.selectionStore);
                return container;
            } },
            react_1.default.createElement(EditorConfigurationContext_1.EditorConfigurationProvider, { value: this.props.configuration },
                react_1.default.createElement(DragContext_1.DragProvider, { value: { allowWidgetDragAndDrop: !disableWidgetDragAndDrop } },
                    react_1.default.createElement(ClientColorProvider_1.ColorProviderProvider, { brandStore: brandStore, blockStore: blockStore },
                        !usingNewTextToolbar && (react_1.default.createElement(Toolbar_1.default, { config: this.getToolBarConfig(), widgetManager: this.widgetManager, brandStore: brandStore, blockStore: blockStore, editorElem: editorElem, telemetry: telemetry, editor: this.editor, currentSelection: (0, mobx_1.toJS)(this.selectionStore.currentSelection), selectionStore: this.selectionStore })),
                        react_1.default.createElement(WidgetAdder_1.default, { widgetManager: this.widgetManager, showImagePicker: showImagePicker, disabled: disableWidgetAdder, editorElem: editorElem, editor: this.editor, usingFeature: this.usingFeature, widgetAdderStore: this.widgetAdderStore, telemetry: telemetry, currentSelection: this.editor.selection, selectionStore: this.selectionStore }),
                        react_1.default.createElement(DropIndicatorLine_1.default, { editor: this.editor, dropLocationStore: this.dropLocationStore }),
                        react_1.default.createElement("div", { className: "widget-toolbar-host", ref: this.widgetToolbarHost }),
                        react_1.default.createElement(slate_react_1.Slate, { editor: this.editor, value: this.value || [], onChange: this.onChange },
                            usingNewTextToolbar && (react_1.default.createElement(TextToolbar_1.TextToolbar, { config: this.getToolBarConfig(), widgetManager: this.widgetManager, blockStore: blockStore, editorElem: editorElem, telemetry: telemetry, selectionStore: this.selectionStore })),
                            react_1.default.createElement(TokenSearchServiceContext_1.default.Provider, { value: tokenSearchService },
                                react_1.default.createElement(StylesContext_1.StylesEditorContextProvider, null,
                                    react_1.default.createElement(DragPreviewImageHost_1.default, { ref: this.dragPreviewImageHost, className: (0, classnames_1.default)("new-editor", blockEditorClass) }),
                                    react_1.default.createElement(slate_react_1.Editable, { disabled: this.waitingForInitialNormalizationToFlush, onKeyDown: function (event) { return _this.router.onEvent(event, _this.editor); }, onClick: function (event) { return _this.router.onEvent(event, _this.editor); }, onCopy: function (event) { return _this.router.onEvent(event, _this.editor); }, onCut: function (event) { return _this.router.onEvent(event, _this.editor); }, onDragStart: function (event) { return _this.router.onEvent(event, _this.editor); }, onDrop: (0, DropUtilities_1.dropHandler)(this.router.onEvent, this.editor), onDragOver: function (event) { return _this.router.onEvent(event, _this.editor); }, onDragEnter: function (event) { return _this.router.onEvent(event, _this.editor); }, onDragEnd: function (event) { return _this.router.onEvent(event, _this.editor); }, onPaste: (0, PasteUtilities_1.pasteHandler)(this.editor, this.router.onEvent, conversionElem, uploadStore), className: (0, classnames_1.default)("new-editor", blockEditorClass, {
                                            "is-showing-drop-indicator": ((_a = this.dropLocationStore.dropLocation) === null || _a === void 0 ? void 0 : _a.editorId) === this.editor.uniqueId,
                                        }), renderElement: this.runRenderElement, renderLeaf: this.runRenderLeaf, readOnly: isReadOnlyMode, decorate: usingNewTextToolbar ? function (entry) { return _this.decorate(entry); } : undefined, onFocus: function () { return _this.selectionStore.setFocussed(true); }, onBlur: function () { return _this.selectionStore.setFocussed(false); }, "data-layout-node": "true", scrollSelectionIntoView: function (editor, domRange) {
                                            var el = slate_react_1.ReactEditor.toDOMNode(editor, editor);
                                            var leafEl = domRange.startContainer.parentElement;
                                            var previousGetBoundingClientRect = leafEl.getBoundingClientRect;
                                            leafEl.getBoundingClientRect = domRange.getBoundingClientRect.bind(domRange);
                                            (0, scroll_into_view_if_needed_1.default)(leafEl, {
                                                scrollMode: "if-needed",
                                                boundary: el,
                                            });
                                            leafEl.getBoundingClientRect = previousGetBoundingClientRect;
                                        } })))),
                        react_1.default.createElement(EditorDebugOverlay_1.EditorDebugOverlay, { editorDebugStore: this.editorDebugStore, editorId: this.editor.uniqueId }))))));
    };
    SlateEditorComponent.prototype.isSavingOperation = function (blockSave, operations) {
        if (!operations || operations.length == 0) {
            return false;
        }
        var firstOperationType = operations[0].type;
        var badOperationType = firstOperationType == "set_selection";
        return !blockSave && !(operations.length == 1 && badOperationType);
    };
    SlateEditorComponent.prototype.decorate = function (_a) {
        var _b = __read(_a, 2), path = _b[1];
        var _c = this.selectionStore, currentSelection = _c.currentSelection, focussed = _c.focussed;
        if (currentSelection &&
            !focussed &&
            !slate_1.Range.isCollapsed(currentSelection) &&
            slate_1.Range.includes(currentSelection, path)) {
            return [__assign(__assign({}, (0, mobx_1.toJS)(currentSelection)), { showSelectionHighlight: true })];
        }
        return [];
    };
    var _a, _b;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Array)
    ], SlateEditorComponent.prototype, "value", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof EditorTypes_1.SlateEditor !== "undefined" && EditorTypes_1.SlateEditor) === "function" ? _a : Object)
    ], SlateEditorComponent.prototype, "editor", void 0);
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", typeof (_b = typeof react_1.default !== "undefined" && react_1.default.RefObject) === "function" ? _b : Object)
    ], SlateEditorComponent.prototype, "widgetToolbarHost", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], SlateEditorComponent.prototype, "waitingForInitialNormalizationToFlush", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array, Object]),
        __metadata("design:returntype", void 0)
    ], SlateEditorComponent.prototype, "onChange", null);
    SlateEditorComponent = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], SlateEditorComponent);
    return SlateEditorComponent;
}(react_1.default.Component));
exports.default = SlateEditorComponent;
var getPendingUsersDataStore = function (di) {
    var rootDataStore = di.get("rootDataStore");
    return rootDataStore.getAccountDataStore().getPendingUsersDataStore();
};
